export default __webpack_public_path__ + "static/media/shootingLogo.74c97d11.png";